/**
 * Devuelve una cadena escapada para insertar en html via innerHTML
 *
 * @param {string} string - la cadena a escapar
 * @return {string}
 */

// Tabla de conversión para escapar caracteres especiales en html entities
const htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;',
};

// RegExp que detecta si una cadena contiene un caracter especial a escapar: & < > " ' `
const specialCharsExp = /[&<>"'`]/g;
// RegExp que detecta si una cadena empieza por un html entities
const startWithEscapedExp = /^(&amp;|&lt;|&gt;|&quot;|&#39;|&#96;)/;

export function htmlEscape(string = '') {
  if (typeof string !== 'string') {
    if (string === null) {
      return '';
    }
    if (typeof string === 'number') {
      string += '';
    } else {
      throw new TypeError(`htmlEscape: argument must be a "string", not a "${typeof string}"`);
    }
  }
  return string.replace(specialCharsExp, _checkAndEscaped);

  function _checkAndEscaped(chr, index) {
    if (chr !== '&') {
      return htmlEscapes[chr];
    }
    // Es el '&', que puede ser de una cadena ya escapada (&amp; ...), no queremos hacer lo 2 veces así que controlamos:
    const restString = string.substring(index, string.length);
    // si el resto de la cadena empieza por una cadena de html entities, no escapamos otra vez
    if (startWithEscapedExp.test(restString)) {
      return '&';
    }
    // sino escapamos el '&''
    return '&amp;';
  }
}
